module.exports = __webpack_public_path__ + "img/CZ07482728.43d645a0.png";